import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AppSettings } from 'src/app/app.settings';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'LocalDate'
})
export class LocalDatePipe implements PipeTransform {


  constructor(
    public appSettings: AppSettings,
  ) { }

  transform(value: any, format: string) {
     
    if (!value) { return ''; }
    if (!format) { format = AppConfigService.appConfig.StandardDateFormat}


    // let noTimeValue = (value.indexOf("T00:00:00") !== -1 || (value.indexOf("T00:00:00") !== -1));

    // // if a shortTime is wished no time will be returned for start and end of day.
    // if (format == 'shortTime' && noTimeValue) {
    //   return "";
    // }



    return formatDate(value, format, AppConfigService.appConfig.CurrentLanguage);
        
}

}
